export function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.substr(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}



export function stringAvatar(email) {
    // console.log(tempUser)
    if (email!=undefined || email!=null) {
        const fullName = email.toString().split("@")[0]
        const firstName = fullName.toString()
            .split(".")
            .map((w) => {
                return w[0].toUpperCase() + w.substr(1).toLowerCase()
            }).join(' ');
        // console.log("this is the firstname", firstName)
        return {
            sx: {
                bgcolor: stringToColor(firstName),
            },
            children: `${firstName.split(' ')[0][0]}${firstName.split(' ')[1]!=undefined ? firstName.split(' ')[1][0]: "" }`,
        };
    } else {
        return {
            sx: {
                bgcolor: stringToColor("???"),
            },
            children: `?`,
        };
    }
}